<template>
    <div class="d-flex featured-ad mb-3" v-if="partAd != null">
        <div class="d-flex flex-column justify-content-center align-items-center p-2">
            <img class="featured-ad-mfr-image" v-bind:src="partAd.manufacturerLogoUrl" />
            <img class="featured-ad-mfr-image" v-bind:src="partImageSrc(partAd.partImageUrl)">
            <a class="font-size-8" target="_blank" v-bind:href="partAd.partImageCreditUrl" v-if="partAd.hasPartImage == true">{{partAd.partImageCreditName}}</a>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-start flex-grow-1 p-2">
            <div>{{partAd.manufacturerName}}</div>
            <div>
                <router-link class="influenced-ad-link-internal" @click="iClick" :to="`/${$store.state.instance}/part/p/${partAd.partUniqueId}/ref/${partAd.referrerTag}/t/${partAd.term}`">{{partAd.manufacturerPartNumber}}</router-link>
            </div>
            <div class="font-size-10" v-if="partAd.hasAdDetailsText == true">{{partAd.adDetailsText}}</div>
            <div class="font-size-14 pt-1">
                {{partAd.description}}
            </div>
            <div class="d-flex model-availability-listing align-items-center justify-content-between pt-1 pb-1" v-if="partAd.dataAvailableOnLeft == true">
                <span class="font-size-14">
                    Data Available:
                </span>
                <div v-bind:class="[partAd.hasSymbol ? 'model-availability-symbol-active' : 'model-availability-symbol-inactive']"></div>
                <div v-bind:class="[partAd.hasFootprint ? 'model-availability-footprint-active' : 'model-availability-footprint-inactive']"></div>
                <div v-bind:class="[partAd.has3D ? 'model-availability-threed-active' : 'model-availability-threed-inactive']"></div>
            </div>
            <div class="font-size-14" v-if="partAd.showPricingOnLeft == true">
                Starting from: <strong>{{partAd.externalStartingPrice}}</strong>
            </div>
            <div class="font-size-14" v-if="partAd.showPricingOnLeft == true">
                Availability: <strong>{{partAd.availabilityText}}</strong>
            </div>
            <div class="pt-1">
                <router-link class="influenced-ad-link-internal btn btn-dark btn-sm" rel="nofollow" @click="iClick" :to="`/${$store.state.instance}/part/p/${partAd.partUniqueId}/ref/${partAd.referrerTag}/t/${partAd.term}`">Download Models</router-link>
            </div>
        </div>
        <div class="featured-ad-divider d-flex justify-content-center align-items-center m-2 p-2" v-if="partAd.showAdvertiserLogo == true">
            <img class="featured-ad-image" v-bind:src="partAd.advertiserLogoUrl" />
        </div>
        <div class="d-flex flex-column pl-2 pb-2">
            <div class="d-flex justify-content-end">
                <div class="sponsored d-flex align-items-center justify-content-center pl-2 pr-2 pt-1 pb-1" v-bind:class="partAd.advertiserBackgroundColorClass">
                    Sponsored
                </div>
            </div>
            <div class="d-flex flex-column flex-grow-1 align-items-center justify-content-center p-2">
                <div class="d-flex flex-row flex-wrap align-items-center justify-content-between pt-2 pb-2" v-if="partAd.dataAvailableOnRight == true">
                    <span class="font-size-14 center-small">
                        Data Available:
                    </span>
                    <div class="model-availability-listing center-small">
                        <div v-bind:class="[partAd.hasSymbol ? 'model-availability-symbol-active' : 'model-availability-symbol-inactive']"></div>
                        <div v-bind:class="[partAd.hasFootprint ? 'model-availability-footprint-active' : 'model-availability-footprint-inactive']"></div>
                        <div v-bind:class="[partAd.has3D ? 'model-availability-threed-active' : 'model-availability-threed-inactive']"></div>
                    </div>
                </div>
                <div class="font-size-14" v-if="partAd.showPricingOnRight == true">
                    Starting from: <strong>{{partAd.externalStartingPrice}}</strong>
                </div>
                <div class="font-size-14" v-if="partAd.showPricingOnRight == true">
                    Availability: <strong>{{partAd.availabilityText}}</strong>
                </div>
                <div class="pt-2 pb-2" v-if="partAd.hasExternalLink">
                    <a @click="eClick" class="influenced-ad-link-external btn btn-light btn-sm d-flex justify-content-start align-items-center" v-bind:class="partAd.advertiserExternalLinkClass">
                        <div v-bind:class="partAd.externalPartLinkCssClass"></div>
                        <div class="pl-1 pr-1">{{partAd.externalPartLinkText}}</div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InfluencedPartAd',
        props: {
            partAd: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        methods: {
            iClick() {
                this.$store.dispatch('gtmInfluenceSearch', { action: 'iClick', eventLabel: this.partAd.eventLabel, eventType: this.partAd.eventType, mfrName: this.partAd.mfrName, mfrPN: this.partAd.mfrPN, term: this.partAd.term, advertiser: this.partAd.advertiser });
            },
            eClick() {
                this.$store.dispatch('gtmInfluenceSearch', { action: 'eClick', eventLabel: this.partAd.eventLabel, eventType: this.partAd.eventType, mfrName: this.partAd.mfrName, mfrPN: this.partAd.mfrPN, term: this.partAd.term, advertiser: this.partAd.advertiser });
                this.$store.dispatch('openUrl', { url: this.partAd.externalPartLink });
            },
            partImageSrc(imgSrc) {
                if (imgSrc != undefined && imgSrc != null && imgSrc != '')
                    return imgSrc;
                return require('../../assets/images/placeholders/Image-Unavailable.png');
            }
        }
    }
</script>

<style scoped>
</style>